export const defaultConfig = {
    itemHeight: 44,
    overscan: 5,
    gap: 0,
};
